module.exports = __webpack_public_path__ + "static/media/Tablet.165b00ae.png";